import React, { useEffect, useRef, useState } from "react";
import SendIcon from "../../icons/SendIcon";
import { CDN_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ReactPlayer from "react-player";
import { FaPlayCircle } from "react-icons/fa";

const StoryRender = ({
  e,
  storys,
  swiper,
  stop,
  setwidth,
  setstep,
  step,
  width,
  setstop,
  array,
  desktop,
  setChat,
  setshow,
  type,
  index,
}) => {
  const [text, setText] = useState();
  const [duration, setduration] = useState();
  const [play, setPlay] = useState(false);
  const [played, setplayed] = useState();
  const [progerss, setprogerss] = useState(0);

  const navigate = useNavigate();
  const videoRef = useRef();

  useEffect(() => {
    if (swiper.activeIndex === index) {
      if (type == "video") {
        if (step < 0) {
          setstop(true);
          setstep(0);
          setwidth(0);
          swiper.slidePrev();
        }
      } else {
        setTimeout(() => {
          if (step < 0) {
            setstop(true);
            setstep(0);
            setwidth(0);
            swiper.slidePrev();
          } else if (stop) {
            return;
          } else {
            if (width >= 100) {
              setwidth(0);
              setstep(step + 1);
            } else {
              setwidth(width + 1);
            }
          }
        }, 50);
      }
    }
  });

  console.log(swiper.activeIndex, play , index , stop);

  function handleOnTouchStart(params) {
    setstep(step);
    setwidth(width);
    setstop(true);
  }

  function handleOnTouchEnd(params) {
    setstep(step);
    setwidth(width);
    setstop(false);
  }

  async function hadleSendChat(e) {
    e.preventDefault();
    await axios
      .get("https://api.ipify.org/?format=json")
      .then(async ({ data }) => {
        navigate(`/chat?text=${text}&ip=${data?.ip}`);
      });
  }

  async function hadleSendChatDesktop(e) {
    e.preventDefault();
    await axios
      .get("https://api.ipify.org/?format=json")
      .then(async ({ data }) => {
        setChat({
          show: true,
          text: `${text}`,
          ip: data?.ip,
        });
        setshow({ show: false, index: null });
      });
  }

  useEffect(() => {
    if (index === swiper.activeIndex) {
      setTimeout(() => {
        setPlay(true);
        setstop(false)
      }, 200);
    }
  }, [swiper.activeIndex]);

  if (desktop) {
    return (
      <>
        <span
          key={e._id}
          style={{
            background:
              "linear-gradient(180deg, rgba(0,0,0,0.48503151260504207) 0%, rgba(0,212,255,0) 100%)",
          }}
          className="absolute left-0 top-0 h-[100px] w-full gra bg-[#00000013] z-10 rounded-[10px]"
        ></span>
        <div className="relative overflow-hidden w-full h-full rounded-[10px]">
          <span
            onClick={() => {
              setstop(true);
              setTimeout(() => {
                setwidth(0);
                setstep(step + 1);
              }, 50);
            }}
            className="absolute top-0 left-0 h-[100vh] w-[25%] z-40"
          ></span>
          <span
            onClick={() => {
              setstop(true);
              setTimeout(() => {
                setwidth(0);
                setstep(step - 1);
              }, 50);
            }}
            className="absolute top-0 right-0 h-[100vh] w-[25%] z-40"
          ></span>
          {type === "video" ? (
            <>
              {!play ? (
                <span
                  className="absolute top-1/2 left-1/2 cursor-pointer -translate-y-1/2 z-20 -translate-x-1/2"
                  onClick={() => setPlay(!play)}
                >
                  {" "}
                  <FaPlayCircle size={60} color="#fff" />
                </span>
              ) : (
                <span
                  onClick={() => setPlay(!play)}
                  className="absolute left-1/2 top-0 h-full w-1/2 z-40 -translate-x-1/2"
                ></span>
              )}
              <ReactPlayer
                muted={false}
                style={{ objectFit: "cover" }}
                className="video-cover rounded-[10px]"
                width={"100%"}
                height={"100%"}
                url={CDN_BASE_URL + storys[step]}
                playing={swiper.activeIndex === index && play}
                playsinline
                progressInterval={100}
                ref={videoRef}
                // onReady={() => {}}
                onProgress={(e) => {
                  if (e.played == 1) {
                    setPlay(false);
                  }
                  setplayed(e.playedSeconds.toFixed());
                  setprogerss(e.played);
                }}
                onEnded={() => {
                  if (swiper.activeIndex === index) {
                    setTimeout(() => {
                      setstep(step + 1);
                    }, 500);
                  }
                }}
                onDuration={(e) => setduration(e)}
                onClickPreview={() => setPlay(!play)}
                onReady={(e)=>console.log(e)}
              />
            </>
          ) : (
            <img
              src={CDN_BASE_URL + storys[step]}
              className={
                desktop
                  ? "w-full h-full object-cover"
                  : "w-full h-full object-cover fixed"
              }
              alt=""
              onLoad={() => stop && setstop(false)}
              onTouchStart={handleOnTouchStart}
              onTouchEnd={handleOnTouchEnd}
            />
          )}

          <div className="flex gap-1 absolute top-[20px] right-0 w-full z-20">
            {storys?.map((e, i) => (
              <span
                style={{
                  width: `${100 / (storys?.length ? storys?.length : 1)}%`,
                  background: step > i ? "#fff" : "#A9ACAC",
                }}
                className="h-[2px] relative"
              >
                {type === "video" ? (
                  <span
                    style={{
                      width: `${(progerss * 100).toFixed()}%`,
                      display: i === step ? "block" : "none",
                    }}
                    className="bg-white h-[2px] duration-200 absolute right-0 top-0"
                  ></span>
                ) : (
                  <span
                    style={{
                      width: `${width}%`,
                      display: i === step ? "block" : "none",
                    }}
                    className="bg-white h-[2px] duration-200 absolute right-0 top-0"
                  ></span>
                )}
              </span>
            ))}
          </div>
          <div className="flex justify-between absolute top-[32px] right-0 w-full px-3 items-center z-20">
            <span className="flex gap-2 items-center">
              <span className="w-[55px] h-[55px] rounded-full p-0.5 bg-white overflow-hidden">
                <img
                  src={CDN_BASE_URL + e.cover}
                  alt={e.name}
                  className=" object-cover w-full h-full"
                  style={{ pointerEvents: "none" }}
                />
              </span>
            </span>
          </div>
          <div className="fixed bottom-3 px-4 w-full z-40">
            <form onSubmit={hadleSendChatDesktop} className="relative  w-full">
              <input
                className="form-brand-mobile w-full bg-transparent text-white placeholder:text-white focus:border-white "
                placeholder="پیام خود را بنویسید ..."
                onClick={() => setstop(true)}
                style={{ paddingLeft: "50px" }}
                onChange={(s) => setText(s.target.value)}
              />
              <button
                onClick={hadleSendChatDesktop}
                type="submit"
                className="fixed  bottom-6 left-7 z-40"
              >
                <SendIcon />
              </button>
            </form>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <span
        key={e._id}
        style={{
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.48503151260504207) 0%, rgba(0,212,255,0) 100%)",
        }}
        className="absolute left-0 top-0 h-[100px] w-full gra bg-[#00000013] z-10"
      ></span>
      <div className="relative  w-full h-full ">
        <span
          onClick={() => {
            setstop(true);
            setTimeout(() => {
              setwidth(0);
              setstep(step + 1);
            }, 50);
          }}
          className="absolute top-0 left-0 h-[100vh] w-[25%] z-40"
        ></span>
        <span
          onClick={() => {
            setstop(true);
            setTimeout(() => {
              setwidth(0);
              setstep(step - 1);
            }, 50);
          }}
          className="absolute top-0 right-0 h-[100vh] w-[25%] z-40"
        ></span>
        {type === "video" ? (
          <span className="relative">
            <ReactPlayer
              muted={false}
              style={{ objectFit: "cover" }}
              className="video-cover rounded-[10px]"
              width={"100%"}
              height={"100%"}
              url={CDN_BASE_URL + storys[step]}
              playing={swiper.activeIndex === index && play}
              progressInterval={100}
              ref={videoRef}
              playsinline
              onProgress={(e) => {
                // if (e.played == 1) {
                //   setPlay(false);
                // }
                setplayed(e.playedSeconds.toFixed());
                setprogerss(e.played);
              }}
              onEnded={() => {
                setTimeout(() => {
                  setstep(step + 1);
                }, 500);
              }}
              onDuration={(e) => setduration(e)}
              onClickPreview={() => setPlay(!play)}
            
            />
            {!play ? (
              <span
                className="absolute left-1/2 top-1/2 cursor-pointer -translate-y-1/2 z-20 -translate-x-1/2"
                onClick={() => setPlay(!play)}
              >
                {" "}
                <FaPlayCircle size={60} color="#fff" />
              </span>
            ) : (
              <span
                onClick={() => setPlay(!play)}
                className="absolute left-1/2 top-0 h-full w-1/2 z-40 -translate-x-1/2"
              ></span>
            )}
          </span>
        ) : (
          <img
            src={CDN_BASE_URL + storys[step]}
            className={
              desktop
                ? "w-full h-full object-cover"
                : "w-full h-full object-cover fixed"
            }
            alt=""
            onLoad={() => stop && setstop(false)}
            onTouchStart={handleOnTouchStart}
            onTouchEnd={handleOnTouchEnd}
            style={{ userSelect: "none" }}
          />
        )}
        <div className="flex gap-1 absolute top-[20px] right-0 w-full z-20">
          {storys?.map((e, i) => (
            <span
              style={{
                width: `${100 / (storys?.length ? storys?.length : 1)}%`,
                background: step > i ? "#fff" : "#A9ACAC",
              }}
              className="h-[2px] relative"
            >
              {type === "video" ? (
                <span
                  style={{
                    width: `${(progerss * 100).toFixed()}%`,
                    display: i === step ? "block" : "none",
                  }}
                  className="bg-white h-[2px] duration-200 absolute right-0 top-0"
                ></span>
              ) : (
                <span
                  style={{
                    width: `${width}%`,
                    display: i === step ? "block" : "none",
                  }}
                  className="bg-white h-[2px] duration-200 absolute right-0 top-0"
                ></span>
              )}
            </span>
          ))}
        </div>
        <div className="flex justify-between absolute top-[32px] right-0 w-full px-3 items-center z-20">
          <span className="flex gap-2 items-center">
            <span className="w-[55px] h-[55px] rounded-full p-0.5 bg-white overflow-hidden">
              <img
                src={CDN_BASE_URL + e.cover}
                alt={e.name}
                className=" object-cover w-full h-full"
              />
            </span>
          </span>
        </div>
        <div className="fixed bottom-3 px-4 w-full z-40">
          <form onSubmit={hadleSendChat} className="relative  w-full">
            <input
              className="form-brand-mobile w-full bg-transparent text-white placeholder:text-white focus:border-white "
              placeholder="پیام خود را بنویسید ..."
              onClick={() => setstop(true)}
              style={{ paddingLeft: "50px" }}
              onChange={(s) => setText(s.target.value)}
            />
            <button
              onClick={hadleSendChat}
              type="submit"
              className="fixed  bottom-6 left-7 z-40"
            >
              <SendIcon />
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default StoryRender;
